/**
 * Phase 8 — Notification status pill.
 */
const TINTS = {
  sent: "bg-emerald-100 text-emerald-900 border-emerald-300",
  failed: "bg-red-100 text-red-900 border-red-300",
  pending: "bg-slate-100 text-slate-700 border-slate-300",
  stubbed_no_provider: "bg-amber-100 text-amber-900 border-amber-300",
};

const LABELS = {
  sent: "Sent",
  failed: "Failed",
  pending: "Pending",
  stubbed_no_provider: "Stub",
};

export default function NotificationStatusBadge({ status }) {
  const cls = TINTS[status] || TINTS.pending;
  return (
    <span
      data-testid={`notif-status-${status}`}
      className={`inline-flex items-center rounded-md border px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide ${cls}`}
    >
      {LABELS[status] || status}
    </span>
  );
}
